import isPlainObject from 'lodash/isPlainObject'

export const isArrayAndNotEmpty = data =>
  data && Array.isArray(data) && data.length > 0

export const isPlainObjectAndNotEmpty = data =>
  data && isPlainObject(data) && Object.keys(data).length > 0

export function getInitData<T extends unknown[] | object | null>(data?: T) {
  return data && (isArrayAndNotEmpty(data) || isPlainObjectAndNotEmpty(data))
    ? {
        initialData: data,
      }
    : {}
}
